import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["list", "item", "template"];

  add() {
    const html = this.templateTarget.innerHTML.replaceAll("NEW_SYSTEM", Date.now());
    this.listTarget.insertAdjacentHTML("beforeend", html);

    this.itemTargets.at(-1).querySelector("input[type='text']").focus({ preventScroll: true });
  }

  remove(event) {
    event.target.closest('[data-systems-target="item"]').remove();
  }
}
